export const LogoMark = ({ className = "h-10 w-10" }) => (
  <img src="/aiwc-logo.png" alt="AIWC logo" data-testid="aiwc-logo-mark"
       className={`${className} rounded-xl object-cover`} />
);

export const Logo = ({ dark = false }) => (
  <div className="flex items-center gap-3" data-testid="nav-logo">
    <LogoMark />
    <div className="leading-none">
      <span className={`font-serif font-bold text-xl tracking-tight ${dark ? "text-cream" : "text-ink"}`}>AIWC</span>
      <span className={`block text-[10px] font-mono uppercase tracking-[0.18em] mt-1 ${dark ? "text-stone-400" : "text-stone-500"}`}>
        AI for Women Community
      </span>
    </div>
  </div>
);
